import React, { useContext, useState, useCallback } from "react";

import { Intro, Text } from "components/commons";
import DataTableV2 from "components/commons/data-table/data-table-v2";
import useDataTable from "hooks/useDataTable";
import locale from "localization";
import styles from "./non-fuel-business.module.scss";
import { mapFilterToRequest, mapDataToList } from "./non-fuel-business.mapper";
import { columns } from "./non-fuel-business-column";
import { initialFilterState } from "./non-fuel-business-filter.state";
import { useModal, useApi } from "hooks";
import NonFuelFilter from "./non-fuel-business-filter";
import { getNonFuelTransaction } from "apis/non-fuel.api";
import { ConfirmModal } from "components/modals";
import { StationContext } from "contexts";
import NonFuelBusinessVoidModal from "./non-fuel-business-void-modal";
import { voidPaymentNonFuel } from "apis/non-fuel.api";
import { formatAmount } from "utils";
import { updatePayment, updatePaymentNonFuel } from "../../../apis";
import DeclareReceiptIssuanceModal from "../payment-history-business/declare-receipt-issuance-modal";

const NonFuelBusinessModule = () => {
  const confirmModal = useModal();
  const voidPaymentModal = useModal();
  const [remarks, setRemarks] = useState("");
  const [value, setValue] = useState("");
  const { station } = useContext(StationContext);
  const { stationId } = station;
  const declareReceiptIssuanceModal = useModal();

  const { request: voidRequest, loading: voidingRequest } = useApi({
    api: voidPaymentNonFuel,
    pageError: false,
    modalError: true,
  });

  const handleDeclareReceiptIssuance = ({ merchantPaymentId }) => {
    declareReceiptIssuanceModal.show({
      merchantPaymentId,
    })
  };
  const { loading: updatingPayment } = useApi({
    api: updatePayment,
    modalError: true,
    pageError: false,
  });

  const handleVoidPayment = ({ merchantPaymentId, amount }) => {
    setRemarks("");
    voidPaymentModal.show({
      title: `${locale.voidTransaction}?`,
      description: (
        <Text align="center">
          <locale.Populate
            text={locale.voidingThisNonFuel}
            items={[<b>{formatAmount(amount)}</b>]}
          />
        </Text>
      ),
      label: locale.reasonRemarks,
      actionText: locale.voidTransaction,
      submit: (value) => {
        onVoidPaymentCb({
          merchantPaymentId,
          value,
          amount,
        });
      },
    });
  };

  const onVoidPaymentCb = useCallback(
    async ({ merchantPaymentId, value, amount }) => {
      await voidRequest({ merchantPaymentId, remarks: value });
      voidPaymentModal.close();
      await table.fetch({});

      confirmModal.show({
        title: locale.transactionVoided,
        content: (
          <locale.Populate
            text={locale.thisTransactionHasBeenVoidedNonFuel}
            items={[<b>{formatAmount(amount)}</b>]}
          />
        ),
        loading: voidingRequest,
        primary: {
          text: locale.gotIt,
          onClick: () => {
            confirmModal.close();
          },
        },
      });
      setRemarks("");
    },
    //eslint-disable-next-line
    [voidRequest, voidPaymentModal, confirmModal, voidingRequest]
  );

  const { filter, search, table } = useDataTable({
    api: {
      api: getNonFuelTransaction,
      params: { stationId, platformType: "plb" },
      mapper: (param) => {
        return param;
      },
    },
    filter: { initialState: initialFilterState(), mapper: mapFilterToRequest },
    table: {
      key: "merchantPayments",
      mapper: (merchantPayments) =>
        mapDataToList({
          merchantPayments,
          handleVoidPayment,
          handleDeclareReceiptIssuance,
        }),
      columns,
    },
  });

  return (
    <>
      <ConfirmModal {...confirmModal} />
      <Intro title={locale.populate(locale.paymentHistoryTitle, [locale.plbNonFuel])} />
      <NonFuelFilter {...filter} {...search} />
      <DeclareReceiptIssuanceModal
        {...declareReceiptIssuanceModal}
        loading={updatingPayment}
        onConfirm={async ({ orNumber }) => {
          await updatePaymentNonFuel({
            merchantPaymentId: declareReceiptIssuanceModal.merchantPaymentId,
            body: { orNumber },
          });
          declareReceiptIssuanceModal.close();
          await table.fetch({});
        }}
      />
      <NonFuelBusinessVoidModal
        {...voidPaymentModal}
        remarks={remarks}
        onChangeRemarks={(v) => {
          setRemarks(v);
        }}
        loading={voidingRequest}
        onSubmit={voidPaymentModal.submit}
        value={value}
        setValue={setValue}
      />
      <div className={styles.table}>
        <DataTableV2 {...table} />
      </div>
    </>
  );
};

export default NonFuelBusinessModule;
